const readEnv = (name) => {
  if (typeof process === "undefined" || !process.env) return "";
  return process.env[name] || "";
};

const GLOBAL_API_KEY =
  readEnv("NEXT_PUBLIC_MEEST_PUBLIC_KEY") ||
  readEnv("REACT_APP_MEEST_PUBLIC_KEY") ||
  readEnv("VITE_MEEST_PUBLIC_KEY");

const COUNTRIES_KEY =
  readEnv("NEXT_PUBLIC_MEEST_COUNTRIES_KEY") ||
  readEnv("REACT_APP_MEEST_COUNTRIES_KEY") ||
  readEnv("VITE_MEEST_COUNTRIES_KEY") ||
  GLOBAL_API_KEY;

const AREAS_KEY =
  readEnv("NEXT_PUBLIC_MEEST_AREAS_KEY") ||
  readEnv("REACT_APP_MEEST_AREAS_KEY") ||
  readEnv("VITE_MEEST_AREAS_KEY") ||
  GLOBAL_API_KEY;

const CITIES_KEY =
  readEnv("NEXT_PUBLIC_MEEST_CITIES_KEY") ||
  readEnv("REACT_APP_MEEST_CITIES_KEY") ||
  readEnv("VITE_MEEST_CITIES_KEY") ||
  GLOBAL_API_KEY;

const BRANCHES_KEY =
  readEnv("NEXT_PUBLIC_MEEST_BRANCHES_KEY") ||
  readEnv("REACT_APP_MEEST_BRANCHES_KEY") ||
  readEnv("VITE_MEEST_BRANCHES_KEY") ||
  GLOBAL_API_KEY;

const COUNTRIES_URL =
  readEnv("NEXT_PUBLIC_MEEST_COUNTRIES_URL") ||
  readEnv("REACT_APP_MEEST_COUNTRIES_URL") ||
  readEnv("VITE_MEEST_COUNTRIES_URL") ||
  "https://publicapi.meest.com/v1/geo/countries";

const AREAS_URL =
  readEnv("NEXT_PUBLIC_MEEST_AREAS_URL") ||
  readEnv("REACT_APP_MEEST_AREAS_URL") ||
  readEnv("VITE_MEEST_AREAS_URL") ||
  "https://publicapi.meest.com/v1/geo/regions";

const CITIES_URL =
  readEnv("NEXT_PUBLIC_MEEST_CITIES_URL") ||
  readEnv("REACT_APP_MEEST_CITIES_URL") ||
  readEnv("VITE_MEEST_CITIES_URL") ||
  "https://publicapi.meest.com/v1/geo/cities";

const BRANCHES_URL =
  readEnv("NEXT_PUBLIC_MEEST_BRANCHES_URL") ||
  readEnv("REACT_APP_MEEST_BRANCHES_URL") ||
  readEnv("VITE_MEEST_BRANCHES_URL") ||
  "https://publicapi.meest.com/v1/geo/branches";

const toQueryString = (params) => {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      search.append(key, String(value));
    }
  });
  const query = search.toString();
  return query ? `?${query}` : "";
};

const extractItems = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.items)) return payload.items;
  if (Array.isArray(payload?.results)) return payload.results;
  if (Array.isArray(payload?.data?.items)) return payload.data.items;
  if (Array.isArray(payload?.result)) return payload.result;
  return [];
};

const getOptionValue = (item) =>
  item?.Ref ||
  item?.ref ||
  item?.id ||
  item?.ID ||
  item?.uuid ||
  item?.code ||
  item?.Code ||
  item?.value ||
  "";

const getOptionLabel = (item) =>
  item?.Description ||
  item?.description ||
  item?.name ||
  item?.Name ||
  item?.title ||
  item?.Title ||
  item?.label ||
  "";

const normalizeOptions = (items) =>
  items
    .map((item) => ({
      Ref: String(getOptionValue(item) || "").trim(),
      Description: String(getOptionLabel(item) || "").trim(),
    }))
    .filter((item) => item.Ref && item.Description);

const request = async (baseUrl, apiKey, params = {}) => {
  const response = await fetch(`${baseUrl}${toQueryString(params)}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      ...(apiKey ? { Authorization: `Bearer ${apiKey}`, "X-Api-Key": apiKey } : {}),
    },
  });

  if (!response.ok) {
    throw new Error(`Meest API error: ${response.status}`);
  }

  const data = await response.json();
  return normalizeOptions(extractItems(data));
};

const withFallback = (params = {}) => ({
  countryId: params.countryRef,
  countryRef: params.countryRef,
  countryCode: params.countryRef,
  regionId: params.areaRef,
  regionRef: params.areaRef,
  cityId: params.cityRef,
  cityRef: params.cityRef,
});

export const getMeestCountries = () => request(COUNTRIES_URL, COUNTRIES_KEY);

export const getMeestAreas = (countryRef) =>
  request(AREAS_URL, AREAS_KEY, withFallback({ countryRef }));

export const getMeestCities = (areaRef) =>
  request(CITIES_URL, CITIES_KEY, withFallback({ areaRef }));

export const getMeestBranches = (cityRef) =>
  request(BRANCHES_URL, BRANCHES_KEY, withFallback({ cityRef }));
